import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <section className="privacy-policy">
      <div className="container">
        <h1>Privacy Policy</h1>
        <p className="effective-date">Effective Date: [Insert Date]</p>
        <p className="business-name">
          <strong>Business Name:</strong> Indvo – Gateway to the Indian Market
        </p>
        <p><strong>Services Covered:</strong></p>
        <ul>
          <li>✅ Indian Market Expansion Infrastructure</li>
          <li>✅ International Product Sourcing (Sourcing Agent Services)</li>
        </ul>
        <p><strong>Contact:</strong> [Insert Contact Email or Form]</p>

        <div className="policy-section">
          <h2>1. Introduction</h2>
          <p>
            At Indvo, your privacy is our priority. We provide two integrated services:
          </p>
          <ul>
            <li>🌐 Business Expansion Infrastructure for international brands entering the Indian market</li>
            <li>📦 Product Sourcing Agent Services for global businesses seeking manufacturers, raw materials, or finished goods from India and other markets</li>
          </ul>
          <p>This Privacy Policy explains how we collect, use, and protect your information across both services.</p>
        </div>

        <div className="policy-section">
          <h2>2. What Information We Collect</h2>
          <h4>📦 For Business Expansion Services</h4>
          <ul>
            <li>Company Name & Owner Details</li>
            <li>Product Type, SKU, and Inventory Volume</li>
            <li>Shipping & Storage Requirements</li>
            <li>Tax and Compliance Documents</li>
            <li>E-commerce Sales Performance (for plan upgrades)</li>
          </ul>

          <h4>🔍 For Sourcing Agent Services</h4>
          <ul>
            <li>Product Requirement Specs</li>
            <li>Budget Range & MOQ</li>
            <li>Target Delivery Dates & Locations</li>
            <li>Supplier Preferences</li>
            <li>Quality Expectations and Sample Reviews</li>
          </ul>

          <h4>🌐 Website and General Use</h4>
          <ul>
            <li>Name, Email, Phone</li>
            <li>IP Address and Browser Type</li>
            <li>Page visit analytics and time spent</li>
            <li>Communication preferences</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>3. How We Use Your Information</h2>
          <ul>
            <li>Provide logistics, payment, and marketplace guidance</li>
            <li>Match with suitable manufacturers or suppliers</li>
            <li>Manage warehousing, delivery, and returns</li>
            <li>Update sourcing timelines and supplier info</li>
            <li>Recommend service upgrades based on your growth</li>
            <li>Ensure legal/tax compliance</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>4. How We Share Your Information</h2>
          <p><strong>We do not sell your information.</strong></p>
          <p>We only share it with trusted partners like:</p>
          <ul>
            <li>Freight forwarders, warehouses, customs agents</li>
            <li>Payment processors</li>
            <li>Indian suppliers and manufacturers</li>
            <li>Legal & compliance consultants</li>
          </ul>
          <p>All third parties sign strict confidentiality agreements.</p>
        </div>

        <div className="policy-section">
          <h2>5. Data Storage and Retention</h2>
          <ul>
            <li>Stored while your business is active with us</li>
            <li>Kept for accounting and compliance</li>
            <li>Used for plan eligibility or repeat sourcing</li>
          </ul>
          <p>You can request data deletion anytime via our support email.</p>
        </div>

        <div className="policy-section">
          <h2>6. Your Rights</h2>
          <ul>
            <li>Access or update your data</li>
            <li>Withdraw communication consent</li>
            <li>Request data deletion</li>
            <li>File complaints with your regional authority</li>
          </ul>
          <p>To exercise rights, email: [Insert Email Address]</p>
        </div>

        <div className="policy-section">
          <h2>7. Security Practices</h2>
          <p>
            We use firewalls, encryption, and access control to protect:
          </p>
          <ul>
            <li>Our web servers</li>
            <li>Internal CRM/logistics tools</li>
            <li>Supplier and contract communications</li>
          </ul>
          <p>However, no digital system is 100% secure. Engagement carries limited risk.</p>
        </div>

        <div className="policy-section">
          <h2>8. Cookies and Analytics</h2>
          <p>We use cookies to:</p>
          <ul>
            <li>Analyze site behavior</li>
            <li>Enhance performance and navigation</li>
            <li>Personalize user experience</li>
          </ul>
          <p>You can disable cookies in your browser, but some features may not work.</p>
        </div>

        <div className="policy-section">
          <h2>9. Third-Party Links & Tools</h2>
          <p>We link to external platforms like Flipkart, Amazon, and factory directories. Their privacy practices may differ. Please review their policies separately.</p>
        </div>

        <div className="policy-section">
          <h2>10. Changes to This Policy</h2>
          <p>We may update this policy to reflect legal or service updates. All changes will be posted here with a new "Effective Date".</p>
        </div>

        <div className="policy-section">
          <h2>11. Contact Information</h2>
          <p>📧 Email: Contact@indvo.com</p>
          <p>🌐 Website: www.indvo.com</p>
          <p>📞 Phone: +91-9407861249</p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
